/* eslint-disable @typescript-eslint/no-explicit-any */
const dataLayer: {
    push(item: any): void
} = ((window as any).dataLayer = (window as any).dataLayer || [])

export default dataLayer
